import frozenViewsBuilder from './frozenViewsBuilder';

import exportFormatsToCustomFormats from '../../utils/exportFormatsToCustomFormats';
import { DataRowBoldStyle } from '../../constants/styles';

const REPORT_FIELDS_TYPES = {
  SUMMARY: 'SUMMARY',
};

const rowTypeToRowStyle = rowType =>
  ({
    [REPORT_FIELDS_TYPES.SUMMARY]: {
      ...DataRowBoldStyle,
    },
  }[rowType] || {});

const buildRowStyles = (rows,
  { hideDecimals, shouldDisplayZero, negativeMinus }
) => {
  const rowStyles = rows.map(row => {
    let rowStyle = {};

    if (row.type) {
      rowStyle = {
        ...rowStyle,
        ...rowTypeToRowStyle(row.type),
      };
    }

    if (row.exportFormat) {
      rowStyle.numFmt = exportFormatsToCustomFormats(
        row.exportFormat, { hideDecimals, shouldDisplayZero, negativeMinus }
      );
    }

    return rowStyle;
  });


  return rowStyles.reduce((acc, style, index) => {
    if (Object.keys(style).length) {
      acc[index] = style;
    }
    return acc;
  }, {});
};

const scenarioReportStyleBuilder = params => {
  const {
    sheetName,
    numberOfRowsToStick,
    numberOfColumnsToStick,
    rowsMeta,
    columnsMeta,
    headerRowsCount,
    sheetMetadataLength,
    hideDecimals,
    shouldDisplayZero,
    negativeMinus,
  } = params;

  const metadata = {
    sheetName,
    views: frozenViewsBuilder({
      rows: numberOfRowsToStick,
      columns: numberOfColumnsToStick,
    }),
    columnStyles: columnsMeta,
    rowStyles: buildRowStyles(rowsMeta,
      { sheetMetadataLength, headerRowsCount },
      { hideDecimals, shouldDisplayZero, negativeMinus }
    ),
    rowMerges: {},
  };

  return metadata;
};

export default scenarioReportStyleBuilder;
